// ABOUTME: Selects the caches affected by profile disqualification changes.
// ABOUTME: Keeps profile and Kanban contexts aligned with stage-change refreshes.

export const applicantHistoryListKey = "/applicant/applicanthistorylist";

export const getDisqualifyRequalifyInvalidationKeys = ({
    isInsideKanban,
    listKeyToInvalidate = []
}: {
    isInsideKanban: boolean;
    listKeyToInvalidate?: string[];
}): string[] =>
    isInsideKanban
        ? [applicantHistoryListKey]
        : Array.from(
              new Set([...listKeyToInvalidate, applicantHistoryListKey])
          );
